import { render, staticRenderFns } from "./ExpressionChildren.vue?vue&type=template&id=b6571644&scoped=true&"
import script from "./ExpressionChildren.vue?vue&type=script&lang=js&"
export * from "./ExpressionChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6571644",
  null
  
)

export default component.exports